import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { ChillingIndex, PlotData } from '../models';

export default class ChillingApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getPlotData(lotId: number): Promise<PlotData>
    {
        const res = await this.http.get('/chilling-api/api/v1/plot/' + lotId + '/data');
        return res.data;
    }

    public async getChilling(lotId: number, dtCalc: Date | null): Promise<ChillingIndex>
    {
        let url = '/chilling-api/api/v1/plot/' + lotId + '/chilling';
        if(dtCalc)
        {
            url += '?dt_calc=' + dtCalc.toISOString();
        }

        const res = await this.http.get(url);
        return res.data;
    }

}
